import {DayOfWeek, LocalDate, TemporalAdjusters} from "@js-joda/core";

const firstDayMapper: Record<number, DayOfWeek> = {
    1: DayOfWeek.MONDAY,
    2: DayOfWeek.TUESDAY,
    3: DayOfWeek.WEDNESDAY,
    4: DayOfWeek.THURSDAY,
    5: DayOfWeek.FRIDAY,
    6: DayOfWeek.SATURDAY,
    7: DayOfWeek.SUNDAY,
};

export function getUserWeekStart() {
    const osLocale = Intl.DateTimeFormat().resolvedOptions().locale;
    const locale = new Intl.Locale(osLocale);

    // This function is not available in Firefox and pre-2024 browser
    // requires polyfill `@bart-krakowski/get-week-info-polyfill`
    // see: https://bugzilla.mozilla.org/show_bug.cgi?id=1693576
    // see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getWeekInfo

    return firstDayMapper[locale.getWeekInfo().firstDay];
}

export function daysBetween(from: LocalDate, to: LocalDate) {
    const days = [];
    let current = from;
    while (!current.isAfter(to)) {
        days.push(current);
        current = current.plusDays(1);
    }

    return days;
}


export function getMonthGridDays(date: LocalDate) {
    const startOfWeek = getUserWeekStart();
    const endOfWeek = startOfWeek.plus(6);

    const from = date
        .with(TemporalAdjusters.firstDayOfMonth())
        .with(TemporalAdjusters.previousOrSame(startOfWeek));

    const to = date
        .with(TemporalAdjusters.lastDayOfMonth())
        .with(TemporalAdjusters.nextOrSame(endOfWeek));

    return daysBetween(from, to);
}

export function getWeekdays() {
    const startOfWeek = getUserWeekStart();
    const days = [startOfWeek];

    let day = startOfWeek.plus(1);
    while (!day.equals(startOfWeek)) {
        days.push(day);
        day = day.plus(1);
    }

    return days;
}